import { render, staticRenderFns } from "./fileLoader.vue?vue&type=template&id=19dcd0d8&scoped=true&"
import script from "./fileLoader.vue?vue&type=script&lang=js&"
export * from "./fileLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dcd0d8",
  null
  
)

export default component.exports